import { namespace } from 'vuex-class';
import { ITemplateUsageState } from '@/content-library/template-usage/store/template-usage.types';

export const TemplateUsage = namespace('contentLibrary/templateUsage');

export enum ETemplateUsageAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  Reset = 'reset',
}

export enum ETemplateUsageMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetTemplates = 'setTemplates',
  SetState = 'setState',
}

export const state: ITemplateUsageState = {
  loading: false,
  loaded: false,
  templates: [],
};
